<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Feriados</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Feriados',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div>
                        <v-btn v-if="$check(['holidays.create'])" id="btnNew" type="button" color="primary"
                            elevation="0" to="feriados/novo">Incluir</v-btn>
                    </div>
                </div>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum feriado encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.name`]="{ item }">
                                <span class="text-uppercase"><strong>{{ item.name }}</strong></span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['holidays.update'])" v-on="on" @click="editHolidays(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar feriado</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['holidays.delete'])" v-on="on" @click="confirmDelete(item)" size="large" class="ml-2">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover feriado</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>
        <!-- MODAL PARA EXCLUIR FERIADO -->
        <v-dialog v-model="dialogConfirmDelete" max-width="400px">
            <v-card>
                <v-card-title>
                    <v-icon large class="mr-2 error--text">mdi-alert-circle-outline</v-icon>
                    Aviso
                </v-card-title>
                <v-card-text class="pt-4 black--text">
                    Você tem certeza que deseja excluir o feriado: <strong>{{ itemToDelete ? itemToDelete.name : ''
                        }}</strong>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="dialogConfirmDelete = false">Cancelar</v-btn>
                    <v-btn color="error darken-1" text @click="deleteHolidays">Excluir</v-btn> </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "HolidaysList",

    data: () => ({
        dataset: {
            data: {}
        },
        dataList: {
            filter: {
                name: "",
            },
            headers: [
                { text: "ID", value: "id" },
                { text: "Nome", value: "name", align: "center" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
        dialogConfirmDelete: false,
        itemToDelete: null,
    }),

    created() {
        this.load();
    },

    methods: {

        formatDate(dateISO) {
            if (!dateISO) return '';
            const date = new Date(dateISO);
            return date.toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        async load() {
            this.dataList.loading = true;

            try {
                const result = await axios.get('api/v2/holidays', { params: { page: this.dataList.options.page, limit: 10 } });

                console.log("Dados: ", result)

                this.dataList.data = result.data.content.data;

                //this.dataList.count = this.dataList.data.length;
                this.dataList.count = result.data.content.total.length

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        editHolidays(item) {
            this.$router.push(`/feriados/${item.id}`);
        },

        confirmDelete(item) {
            this.itemToDelete = item;
            this.dialogConfirmDelete = true;
        },

        async deleteHolidays() {

            this.dialogConfirmDelete = false;

            if (!this.itemToDelete) return;

            this.dataList.loading = true;
            try {
                const response = await axios.delete(`api/v2/holidays/${this.itemToDelete.id}`);

                if (response.status === 200 || response.status === 204) {
                    this.$dialog.notify.success('Feriado excluído com sucesso!', { position: 'top-right', timeout: 3000 });
                    this.load();
                }
            } catch (error) {
                console.error('Erro ao excluir feriado:', error);
                let errorMessage = "Erro desconhecido ao excluir feriado.";
                this.$dialog.notify.error(errorMessage, { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
                this.itemToDelete = null;
            }
        },


    },
};
</script>